/** @see https://github.com/zenorocha/select */
const deselectCurrentSelection = () => {
    var selection = document.getSelection();
    if (!selection.rangeCount) {
        return function () { };
    }
    var active = document.activeElement;
    var ranges = [];
    for (var i = 0; i < selection.rangeCount; i++) {
        ranges.push(selection.getRangeAt(i));
    }
    switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function () {
        selection.type === 'Caret' &&
            selection.removeAllRanges();
        if (!selection.rangeCount) {
            ranges.forEach(function (range) {
                selection.addRange(range);
            });
        }
        active &&
            active.focus();
    };
};
/**
 * 复制功能
 * @param {string} text - 需要复制的文本
 * @return {Promise<unknown>} Promise<any>
 * @see https://github.com/sudodoki/copy-to-clipboard
 */
export default (text) => {
    return new Promise((resolve, reject) => {
        let reselectPrevious;
        let range;
        let selection;
        let fakeElem;
        let success = false;
        try {
            reselectPrevious = deselectCurrentSelection();
            fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            fakeElem.style.fontSize = '12pt';
            // Reset box model
            fakeElem.style.border = '0';
            fakeElem.style.padding = '0';
            fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            fakeElem.style.position = 'absolute';
            fakeElem.style.left = '-9999px';
            fakeElem.style.opacity = '0';
            // Move element to the same position vertically
            fakeElem.style.top = `${window.pageYOffset || document.documentElement.scrollTop}px`;
            fakeElem.setAttribute('readonly', '');
            // set text
            fakeElem.value = text;
            document.body.appendChild(fakeElem);
            fakeElem.select();
            fakeElem.setSelectionRange(0, fakeElem.value.length);
            var successful = document.execCommand('copy');
            if (!successful) {
                throw new Error('copy command was unsuccessful');
            }
            success = true;
        }
        catch (err) {
            try {
                window.clipboardData.setData('text', text);
                success = true;
            }
            catch (err) {
                window.prompt('请手动选择复制', text);
            }
        }
        finally {
            if (selection) {
                if (typeof selection.removeRange === 'function') {
                    selection.removeRange(range);
                }
                else {
                    selection.removeAllRanges();
                }
            }
            if (fakeElem) {
                document.body.removeChild(fakeElem);
            }
            reselectPrevious();
        }
        success ? resolve() : reject();
    });
};
